"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenusSink = void 0;
const icons_1 = require("client/components/icons");
const menu_1 = require("client/components/menu");
const icon_button_1 = require("client/components/ui/icon-button");
const text_field_1 = require("client/components/ui/text-field");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const ramda_1 = require("ramda");
const react_1 = require("react");
const React = require("react");
require("./menus.less");
let MenusSink = class MenusSink extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showMenu1 = false;
        this.showMenu2 = false;
        this.showMenu3 = false;
        this.showMenu4 = false;
        this.textField = "";
    }
    render() {
        const data = ramda_1.range(1, 10).map(i => ({
            id: i,
            label: `Someone ${i}`,
            value: i.toString(),
            icon: React.createElement(icons_1.SitesIcon, null)
        }));
        return (React.createElement("div", null,
            React.createElement("h2", null, "Menu"),
            React.createElement("div", { className: "menus" },
                React.createElement(menu_1.Menu, { data: data, onAction: () => {
                        this.showMenu1 = false;
                    }, showMenu: this.showMenu1 },
                    React.createElement(icon_button_1.UiIconButton, { onClick: () => {
                            this.showMenu1 = !this.showMenu1;
                        } },
                        React.createElement(icons_1.MenuIcon, null))),
                React.createElement(menu_1.Menu, { data: data, showMenu: this.showMenu2, onAction: () => {
                        this.showMenu2 = false;
                    } },
                    React.createElement("a", { className: "menu-component__input", onClick: () => {
                            this.showMenu2 = true;
                        } },
                        React.createElement(text_field_1.UiTextField, { className: "search", leftItem: React.createElement(icons_1.SearchIcon, { fill: "#8b919f" }), value: this.textField, onChange: (event) => (this.textField = event.target.value) }))),
                React.createElement(menu_1.Menu, { data: data, showMenu: this.showMenu3, onAction: () => {
                        this.showMenu3 = false;
                    } },
                    React.createElement("a", { className: "menu-component__text-button", onClick: () => {
                            this.showMenu3 = !this.showMenu3;
                        } },
                        React.createElement("label", null, "View Tickets"),
                        " In the order",
                        React.createElement(icons_1.Chevron, null))),
                React.createElement(menu_1.Menu, { alignItems: "right", data: data, onAction: () => {
                        this.showMenu4 = false;
                    }, showMenu: this.showMenu4 },
                    React.createElement("a", { className: "menu-component__text-button", onClick: () => {
                            this.showMenu4 = !this.showMenu4;
                        } },
                        React.createElement("label", null, "Right Aligned"),
                        " Menu",
                        React.createElement(icons_1.Chevron, null))))));
    }
};
__decorate([
    mobx_1.observable
], MenusSink.prototype, "showMenu1", void 0);
__decorate([
    mobx_1.observable
], MenusSink.prototype, "showMenu2", void 0);
__decorate([
    mobx_1.observable
], MenusSink.prototype, "showMenu3", void 0);
__decorate([
    mobx_1.observable
], MenusSink.prototype, "showMenu4", void 0);
__decorate([
    mobx_1.observable
], MenusSink.prototype, "textField", void 0);
MenusSink = __decorate([
    mobx_react_1.observer
], MenusSink);
exports.MenusSink = MenusSink;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/menus/menus.tsx
// module id = 3653
// module chunks = 0